import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./educationalTours.scss";

function EducationalToursList() {
  const navigate = useNavigate();
  const [tours, setTours] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const breadcrumbItems = [
    { title: "Educational Tours", link: "#" },
    { title: "Educational Tours List", link: "#" },
  ];

  React.useEffect(() => {
    fetchTours();
  }, []);

  const fetchTours = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/educational-tours`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Educational tours data:', data);
        setTours(Array.isArray(data) ? data : data.data || []);
      } else {
        setTours([]);
      }
    } catch (error) {
      console.error('Error fetching educational tours:', error);
      setTours([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (tour) => {
    navigate(`/edit-educational-tour/${tour._id}`, { state: { tour } });
  };

  const handleDelete = async (tourId) => {
    if (window.confirm("Are you sure you want to delete this educational tour?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/educational-tours/${tourId}`, {
          method: 'DELETE',
          headers: { "ngrok-skip-browser-warning": "true" },
        });
        
        if (response.ok) {
          setTours(tours.filter(item => item._id !== tourId));
        } else {
          console.error('Failed to delete educational tour');
        }
      } catch (error) {
        console.error('Error deleting educational tour:', error);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Educational Tour List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-educational-tour">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Educational Tour
                      </Button>
                    </Link>
                  </div>
                  {loading ? (
                    <div className="text-center py-4">Loading educational tours...</div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table table-centered table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>State / Country Name</th>
                            <th>Tour Name</th>
                            <th>Tour Image</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tours.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center py-4">
                                No educational tours found.
                              </td>
                            </tr>
                          ) : (
                            tours.map((tour, index) => (
                              <tr 
                                key={tour._id || index}
                                className="tour-row"
                              >
                                <td>{tour._id || index + 1}</td>
                                <td>{tour?.category_name || "N/A"}</td>
                                <td>{tour?.tour_name || tour?.title || "N/A"}</td>
                                <td>
                                  {tour.tour_image ? (
                                    <img
                                      src={`${config.IMAGE_URL}/${tour.tour_image}`}
                                      alt={tour.tour_name || "Tour"}
                                      width="50"
                                      height="50"
                                      className="rounded"
                                    />
                                  ) : (
                                    <div className="avatar-xs">
                                      <span className="avatar-title rounded bg-primary-subtle text-primary fw-bold">
                                        E
                                      </span>
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <span className="badge bg-success">
                                    Active
                                  </span>
                                </td>
                                <td>
                                  <button 
                                    className="tour-action-buttons me-2 text-primary"
                                    onClick={() => handleEdit(tour)}
                                    title="Edit"
                                  >
                                    <i className="ri-pencil-fill"></i>
                                  </button>
                                  <button 
                                    className="tour-action-buttons text-danger"
                                    onClick={() => handleDelete(tour._id)}
                                    title="Delete"
                                  >
                                    <i className="ri-delete-bin-fill"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default EducationalToursList;
